module.exports = __webpack_public_path__ + "img/calender-icon.885785c9.svg";